import { supabase } from "./supabaseClient";
import { GraphQLClient } from "graphql-request";

async function mkClient() {
  const token = (await supabase.auth.getSession()).data.session?.access_token;

  const client = new GraphQLClient(`${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/graphql/v1`, {
    headers: {
      authorization: token ? `Bearer ${token}` : "",
      apikey: import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY
    }
  });
  return client;
}

export default mkClient;
